import { FETCH_VERSION } from '../actions/types';

export default function (state = null, action) {
  switch (action.type) {
    case FETCH_VERSION:
      return action.payload;
    default:
      return state;
  }
}